import { render, staticRenderFns } from "./AgentLeaveModal.vue?vue&type=template&id=47dfdb28&"
import script from "./AgentLeaveModal.vue?vue&type=script&lang=js&"
export * from "./AgentLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47dfdb28')) {
      api.createRecord('47dfdb28', component.options)
    } else {
      api.reload('47dfdb28', component.options)
    }
    module.hot.accept("./AgentLeaveModal.vue?vue&type=template&id=47dfdb28&", function () {
      api.rerender('47dfdb28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/AgentLeaveModal.vue"
export default component.exports